import React from 'react'
import { CustomText } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { getFormatedPrice } from 'src/core/helpers'
import { ProjectDiscountPayload } from 'src/core/models'
import { projectCurrencyTokenCodeSelected } from 'src/features'

const ProjectDiscountAmountColumn: React.FC<{ discount: ProjectDiscountPayload }> = ({ discount }) => {
  const currencyCode = useAppSelector(projectCurrencyTokenCodeSelected)

  const label = {
    'PERCENTAGE': `${discount.amount} %`,
    'FLAT_AMOUNT': getFormatedPrice(discount.amount, currencyCode)
  }[discount.amount_type]

  return <CustomText label={label} />
}

export default ProjectDiscountAmountColumn
